export default __webpack_public_path__ + "static/media/pattern-iPattern1.556aeeb2.jpg";